import { useEffect, useState, useRef, useContext } from 'react'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom'
import AuthContext from '../../providers/AuthContext'
import language from '../../variables/language'

const LoginForm = () => {

    const label = "login"

    const { 
        setIsLoggedIn, 
        setFirstName, 
        setLastName, 
        setUserId,
        timeZone,
        isLoggedIn
    } = useContext(AuthContext)

    const errRef = useRef()

    const [login, setLogin] = useState("")
    const [password, setPassword] = useState("")
    const [errMsg, setErrMsg] = useState("")
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (isLoggedIn && location.pathname === "/login") {
            navigate("/dashboard")
        }
    }, [isLoggedIn, location.pathname, navigate])


    const handleSubmit = async (e) => {

        e.preventDefault()
        setLoading(true)
        setErrMsg("")

        try {

            const response = await axios.post(
                "/api/authentication",
                { login, password, timeZone },
                { withCredentials: true }
            )

            setFirstName(response.data.imie)
            setLastName(response.data.nazwisko)
            setUserId(response.data.id)
            setIsLoggedIn(true)

            navigate("/")

        } catch (err) {

            if (!err.response) {
                setErrMsg("Brak połączenia z serwerem")
            } 
            else if (err.response.status === 401) {
                setErrMsg("Błędny login lub hasło")
            } 
            else {
                setErrMsg("Wystąpił błąd")
            }

            errRef.current?.focus()

        } finally {
            setLoading(false)
        }
    }


    return (

        <div className="login-form-container">

            <div className="login-form-block">

                <div className="login-form-header">
                    <h2 className="login-form-header-txt">
                        {language[language.lang].pages[label].loginTitle}
                    </h2>
                </div>

                <div className="login-form-body">

                    <form onSubmit={handleSubmit}>

                        <div className="inpt-login">
                            <input
                                placeholder={language[language.lang].pages[label].loginPlaceholder}
                                value={login}
                                onChange={(e) => setLogin(e.target.value)}
                                type="text"
                                required
                                className="login-input"
                            />
                        </div>

                        <div className="inpt-login">
                            <input
                                placeholder={language[language.lang].pages[label].passPlaceholder}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                type="password"
                                required
                                className={`login-input ${errMsg ? "errmsg" : ""}`}
                            />
                        </div>

                        <p
                            ref={errRef}
                            className={errMsg ? "errmsg" : "offscreen"}
                            aria-live="assertive"
                        >
                            {errMsg}
                        </p>

                        <button 
                            type="submit" 
                            className="btn-login"
                            disabled={loading}
                        >
                            {loading 
                                ? "Loading..." 
                                : language[language.lang].pages[label].loginButton
                            }
                        </button>

                    </form>

                </div>
            </div>
        </div>
    )
}

export default LoginForm